import Vue from 'vue'
import App from './App.vue'
import router from './route/index'
import './registerServiceWorker'
import 'font-awesome/css/font-awesome.min.css'
import Toasted from 'vue-toasted';
import VueResource from 'vue-resource';
import VueCookie from 'vue-cookie'
import i18n from '@/utils/i18n'
import VueQrcodeReader from "vue-qrcode-reader";
import VueCarousel from 'vue-carousel';
import store from './store/store';
import Vuelidate from "vuelidate";
// import * as Sentry from '@sentry/browser';
// import * as Integrations from '@sentry/integrations';
import VuelidateErrorExtractor, { templates } from "vuelidate-error-extractor";
import StarRating from 'vue-star-rating';
import VueTimeago from 'vue-timeago';
import './assets/css/style.css';
import * as VueGoogleMaps from "vue2-google-maps";
Vue.config.productionTip = false
Vue.use(VueResource);
Vue.use(VueCookie);
Vue.use(VueQrcodeReader);
Vue.use(VueCarousel);
Vue.component('star-rating', StarRating);
window.__native_money91 = {}

Vue.use(VueTimeago, {
    name: 'Timeago',
    // locale: $cookies.get('lang') || 'hi',
    locales: {
        locale: require('../src/utils/i18n')
    }
});
Vue.use(Toasted, {
    theme: "bubble",
    duration: 2000,
    // position: 'top-left'
});
Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyDQQbGL9oTLjM2nMNDqJDITRp56op7QM80",
        libraries: "places" // necessary for places input
    }
});

Vue.use(Vuelidate);
Vue.use(VuelidateErrorExtractor, {
    i18n: false,
    messages: {
        required: "{attribute} is necessary!",
        isBusiness: "{attribute} must be valid",
        isCity: "{attribute} must be valid",
        isPincode: "{attribute} must be valid",
        isMobile: "{attribute} must be valid",
        isAadhaarNumber: "{attribute} must be valid",
        isPanNumber: "{attribute} must be valid"
    }
});

// Sentry.init({
//   environment: window.location.hostname === "localhost" ? 'staging' : 'production',
//   dsn: 'https://064bc89be4b349c5a2c656daf59f5b5d@sentry.io/1731450',
//   integrations: [new Integrations.Vue({ Vue, attachProps: true })],
// });

Vue.component("form-group", templates.singleErrorExtractor.foundation6);

new Vue({
    i18n,
    router,
    store,
    render: function(h) { return h(App) }
}).$mount('#app')